import React from 'react';
import unified from 'unified';
import externalLinks from 'remark-external-links';
import html from 'remark-html';
import markdown from 'remark-parse';
import classNames from 'classnames';

export const TextAlignTypeOptions = ['left', 'center', 'right'];
type TextAlign = (typeof TextAlignTypeOptions)[number];

interface TextProps {
  /** Alignment of the text and headline. */
  align?: TextAlign;
  /** The text or textelements to display. */
  children: React.ReactNode;
  /** CSS class name */
  className?: string;
  /** Headline for the text. */
  header?: React.ReactNode;
}

const Text = ({ align, children, className, header }: TextProps) => {
  const markDownedchildren = (
    children instanceof Array ? children : [children]
  ).map((element, index) => {
    if (typeof element === 'string') {
      const mardownString = element
        .split('\n')
        .map((line) => line.trim())
        .join('\n');
      const htmlString = unified()
        .use(markdown as any) // TODO: Check correct types.
        .use(externalLinks, { target: '_blank' })
        .use(html)
        .processSync(mardownString).contents;
      return (
        <div
          // eslint-disable-next-line react/no-array-index-key
          key={`index_${index}`}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: htmlString.toString() }}
        />
      );
    }
    // eslint-disable-next-line react/no-array-index-key
    return <div key={`index_${index}`}>{element}</div>;
  });
  return (
    <div
      className={classNames(
        className,
        `ce ce-text${align ? ` text-${align}` : ''}`,
      )}
    >
      {header}
      {markDownedchildren}
    </div>
  );
};

Text.defaultProps = {
  align: null,
  className: null,
  header: null,
};

export default Text;
